<script setup lang="ts">
	import { ref, watch } from "vue";
	import CopyIcon from "@/icons/CopyIcon.vue";
    import MagicCopyIcon from "@/icons/MagicCopyIcon.vue"; 

	const props = defineProps<{
		text: string;
		displayText: string;
        magicIcon?: boolean; // Optional prop to use MagicCopyIcon
	}>();

	const copied = ref(false);

	const copyText = async () => {
		try {
			await navigator.clipboard.writeText(props.text);
			copied.value = true;
		} catch (err) {
			console.error("Failed to copy:", err);
		}
	};

	watch(copied, newVal => {
		if (newVal) {
			setTimeout(() => (copied.value = false), 2000);
		}
	});
</script>

<template>
	<div class="relative inline-block flex items-center">
		<span class="mr-2 break-normal md:break-all">
			{{ displayText }}
		</span>
		<button
			@click="copyText"
			class="custom-button flex"
		>
            <MagicCopyIcon
                v-if="props.magicIcon"
                class="!w-12 !h-12 align-center"
            />
			<CopyIcon v-else class="align-center !h-12 !w-12" />
		</button>
		<span
			v-if="copied"
			class="absolute right-0 top-0 rounded bg-green-950 p-1 text-xs text-white"
		>
			Copied!
		</span>
	</div>
</template>
